import React from "react";
import CallToAction from "../partials/cta";
import CheckOccupation from "./occupation";
import FieldLabel from "../../../components/label";
import SectionTitle from "../../../components/sectionTitle";
import { Box } from "@mui/material";
import { BUTTON_PROCEED } from "../../../constants";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";

function BuyflowGuidelineForm({
  classes: { containerButton, contentScroller, main, formGroup },
  errorMessage = {},
  handleBack,
  isFormSubmitted,
  form,
  onSubmit,
  selectedOccupationOption,
  setSelectedOccupationOption,
}) {
  return (
    <Box className={main} mt={2}>
      <Box>
        <form noValidate autoComplete="off" onSubmit={onSubmit}>
          <Box display="flex" justifyContent="center">
            <SectionTitle
              title={"Journey Guideline"}
              onClickHandler={handleBack}
            />
          </Box>

          <Box
            mt={2}
            className={`${contentScroller}`}
            justifyContent="flex-start"
            textAlign={"left"}
          >
            <Box className={formGroup} pb={0}>
              <FieldLabel label="1. Be ready with your PAN number." />
            </Box>
            <Box className={formGroup} pb={0}>
              <FieldLabel label="2. Check your occupation eligibility." />
            </Box>
            <CheckOccupation
              selectedOccupationOption={selectedOccupationOption}
              setSelectedOccupationOption={setSelectedOccupationOption}
            />
          </Box>

          <Box
            className={containerButton}
            justifyContent="center"
            alignContent="center"
          >
            <CallToAction
              buttonType={"submit"}
              errorMessage={errorMessage}
              form={form}
              isFormSubmitted={isFormSubmitted}
              text={BUTTON_PROCEED}
              handleClick={() => {}}
              isDisabled={
                selectedOccupationOption?.risk_categorization === "High"
              }
            />
          </Box>
        </form>
      </Box>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(BuyflowGuidelineForm);
